
import { DISH_TYPE, MenuDish} from "@/types/home";
import { convertRemToPx } from "@/utils/common-utils";
import { getRecipeImage } from "@/utils/search-util";
import { defineComponent, SetupContext, computed } from "vue";
import CommonRecipeFoodIds from "@/components/commonRecipe/CommonRecipeFoodIds.vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  components: {
    CommonRecipeFoodIds
  },
  name: "RecommendFoodMenuItem",
  props: {
    dishType: {
      type: String,
      default: DISH_TYPE.MAIN
    },
    dish: {
      type: MenuDish,
      default: null,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const MAIN_DISH_NAME_HEIGHT = 3;
    const SUB_DISH_NAME_HEIGHT = 5.1;
    const IMAGE_HEIGHT = 17.5;
    const styleImage = computed (() => {
      let height = convertRemToPx(IMAGE_HEIGHT);
      if (props.dishType == DISH_TYPE.MAIN) {
        height -= convertRemToPx(MAIN_DISH_NAME_HEIGHT)
      } else {
        height -= convertRemToPx(SUB_DISH_NAME_HEIGHT);
      }
      return { height: height + 'px' };
    });
    const styleNameView = computed (() => {
      let height;
      if (props.dishType == DISH_TYPE.MAIN) {
        height = convertRemToPx(MAIN_DISH_NAME_HEIGHT);
      } else {
        height = convertRemToPx(SUB_DISH_NAME_HEIGHT);
      }
      return { height: height + 'px' };
    });
    const styleNameText = computed(() => {
      let line;
      if (props.dishType == DISH_TYPE.MAIN) {
        line = 1;
      } else {
        line = 2;
      }
      return { '-webkit-line-clamp': line };
    });
    const styleFoodView = computed(() => {
      let marginBottom;
      if (props.dishType == DISH_TYPE.MAIN) {
        marginBottom = convertRemToPx(MAIN_DISH_NAME_HEIGHT + 0.2);
      } else {
        marginBottom = convertRemToPx(SUB_DISH_NAME_HEIGHT + 0.2);
      }
      return { "margin-bottom": marginBottom + 'px' };
    });
    const getDish = () => {
      return (props.dishType == DISH_TYPE.MAIN) ? "主菜" : "副菜";
    };
    const getImage = () => {
      let imageUrl = null; 
      if (props.dish != null && props.dish.recipe != null && props.dish.recipe.images != null && props.dish.recipe.images.length >= 1) {
        imageUrl = getRecipeImage(props.dish.recipe.images[0]);
      }
      return imageUrl;
    };
    const getName = () => {
      let name = "";
      if (props.dish != null && props.dish.recipe != null && props.dish.recipe.title != null) {
        name = props.dish.recipe.title;
      }
      return name;
    };
    /**
     * 画像読み込みエラー発生
     */
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("RecommendFoodMenuItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("RecommendFoodMenuItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/noimage1.png"); 
      }
    };
    const onClickRecipe = () => {
      if (props.dish && props.dish.recipe) {
        context.emit("select-recipe", props.dish.recipe.recipeId, props.dish.recipe.type);
      }
    };
    const getFoodIds = () => {
      return props.dish && props.dish.foodIds ? props.dish.foodIds : [];
    };
    return {
      styleImage,
      styleNameView,
      styleNameText,
      styleFoodView,
      getDish,
      getImage,
      getName,
      onImageError,
      onClickRecipe,
      getFoodIds
    };
  }
});
